import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
} from 'reactstrap';
import styles from './styles.module.scss';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Caret from '../../public/site-assets/svg/caret.svg';
import { useEffect } from 'react';

export default function NewImageWithText({
    customClass = "",
    post
}) {
    useEffect(() => {
        Fancybox.bind("[data-fancybox]", {});
        return () => {
            Fancybox.destroy();
        };
    }, []);

    return (
        <>
            <div className={`${styles.root} ${customClass}`}>
                <Container>
                    <div className="d-flex gap-5 flex-wrap">
                        {post.map((post, index) =>
                            <div className="item d-flex gap-5 flex-wrap flex-lg-nowrap w-100 align-items-center" key={index}>
                                <div className="column">
                                    <div dangerouslySetInnerHTML={{ __html: post.content }} />
                                    {post.buttonlink && (
                                        <a className="primaryBtn no-arrow" href={`${post.buttonlink}`}>{post.buttontitle}</a>
                                    )}
                                </div>
                                <div className="column">
                                    {post.video_link ?
                                        <a
                                            className="fancyBox d-inline-block position-relative"
                                            data-fancybox={`${post.id}`}
                                            href={post?.video_link}
                                            aria-label="Play"
                                        >
                                            <span className="play position-absolute center">
                                                <Caret />
                                            </span>
                                            <div className="overflow-hidden rounded-4">
                                                <SourceFlowImage
                                                    src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                    size="1000x"
                                                    alt={`Image ${index}`}
                                                    className="card-img"
                                                    width="100%"
                                                    height="100%"
                                                />
                                            </div>
                                        </a> :
                                        <SourceFlowImage
                                            src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                            size="1000x"
                                            alt={`Image ${index}`}
                                            className="card-img rounded-4"
                                            width="100%"
                                            height="100%"
                                        />}
                                </div>
                            </div>
                        )}
                    </div>
                </Container>
            </div>
        </>
    )
}